/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { Button, Modal } from "react-bootstrap";

interface ModalFooterProps {
  onClose: () => void;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  submitLabel?: string;
  showSubmit?: boolean;
}

const CloseButton: React.FC<ModalFooterProps> = ({
  onClose,
  onSubmit,
  loading = false,
  disabled = false,
  submitLabel = "Submit",
  showSubmit = true,
}) => {
  return (
    <Modal.Footer className="pe-0 pb-0 mt-4">
      <Button
        className="btn btn-cancel rounded-5 small me-2 mt-1"
        onClick={onClose}
      >
        Cancel
      </Button>

      {showSubmit && (
        <button
          disabled={disabled}
          onClick={onSubmit}
          className="btn btn-outline-primary rounded-5 me-2"
        >
          {!loading && <span className="indicator-label">{submitLabel}</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      )}
    </Modal.Footer>
  );
};

export default CloseButton;
